import { render } from "./vue-tel-input.vue?vue&type=template&id=9de3765c"
import script from "./vue-tel-input.vue?vue&type=script&lang=js"
export * from "./vue-tel-input.vue?vue&type=script&lang=js"

import "../assets/sprite.css?vue&type=style&index=0&lang=css"
import "./vue-tel-input.vue?vue&type=style&index=1&id=9de3765c&lang=css"

import exportComponent from "C:\\Projects\\BijouCRM\\src\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__